import React from 'react'
import { ExternalLink } from '@/atoms/ExternalLink'
import { LinkedInLettersIcon } from '@/atoms/Icons/LinkedInLettersIcon'
import { RedditCircleIcon } from '@/atoms/Icons/RedditCircleIcon'
import { CaptionSM } from '@/atoms/Text'
import { IconColor, OneColorIconProps } from '@/atoms/utils'
import { useSocialSharing } from '@/organisms/SocialSharing'
import { createPlaceholderArray } from '@/utils/PlaceholderArrays'

const socialList = ['facebook', 'twitter', 'reddit', 'linkedIn', 'email']
const iconOverrides = {
  reddit: RedditCircleIcon,
  linkedIn: LinkedInLettersIcon,
} as Record<string, React.FC<OneColorIconProps>>

interface ShareMomentSocialsProps {
  url?: string | null
  trackShareClick: (network: string) => void
}

export const ShareMomentSocials: React.FC<ShareMomentSocialsProps> = ({ url, trackShareClick }) => {
  const { socials } = useSocialSharing({ shareUrl: url as string })

  return (
    <div className="mb-7 flex justify-between gap-3 md:gap-4">
      {url
        ? socialList.map((social) => {
            const Icon = iconOverrides[social] ?? socials[social].icon
            const color = socials[social].brandColor
            return (
              <ExternalLink
                key={social}
                href={socials[social].href as string}
                className="flex cursor-pointer flex-col items-center"
                onClick={() => {
                  trackShareClick(social)
                }}
              >
                <div className="mb-2 flex h-[56px] w-[56px] items-center justify-center rounded-full bg-white hover:bg-white/80 active:bg-white/75">
                  <Icon size={24} color={color as IconColor} />
                </div>
                <CaptionSM color="core-gray-500">{socials[social].name}</CaptionSM>
              </ExternalLink>
            )
          })
        : createPlaceholderArray(5).map((v) => {
            return (
              <div key={v}>
                <div className="mb-2 h-[56px] w-[56px] animate-pulse rounded-full bg-gray-600" />
                <CaptionSM color="core-gray-500">&nbsp;</CaptionSM>
              </div>
            )
          })}
    </div>
  )
}
